import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a003a3c0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "info-box",
  id: "InfoBox"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, "短信发送记录信息", -1));
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { getSmsRecordById } from '@/api/sms';
import { PLATFORM_TYPE } from '../sms-module/config';
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const {
      id
    } = route.params;
    console.log(id);
    const data = ref({});
    const loading = ref(false);
    const getData = async () => {
      loading.value = true;
      const res = await getSmsRecordById(id);
      data.value = res;
      loading.value = false;
    };
    getData();
    return (_ctx, _cache) => {
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
      const _component_el_descriptions = _resolveComponent("el-descriptions");
      const _component_el_card = _resolveComponent("el-card");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_card, {
        shadow: "never"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _withDirectives((_openBlock(), _createBlock(_component_el_descriptions, {
          column: 2,
          border: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
            label: "短信接入方唯一标识"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.appId), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "短信接入方名称"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.appName), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "接入的短信平台"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(PLATFORM_TYPE)[data.value.platform]), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "短信发送回执id"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.bizId), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "该条短信发送响应状态code",
            span: 2
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.code), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "该条短信发送响应信息"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.message), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "调用方请求参数"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.params), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "接收方手机号"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.phones), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "备注"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.remark), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "短信发送请求id"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.requestId), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "发送内容",
            span: 2
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.sendContent), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "第三方平台模板编号",
            span: 2
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.templateCode), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            span: 2,
            label: "第三方平台模板名称",
            direction: "vertical"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.templateName), 1)]),
            _: 1
          })]),
          _: 1
        })), [[_directive_loading, loading.value]])])]),
        _: 1
      });
    };
  }
};